/**
 * i18n Configuration for IMKI
 *
 * Supported languages:
 * - de: German (default)
 * - ar: Arabic (RTL)
 * - en: English
 */

export const locales = ['de', 'ar', 'en'] as const
export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'de'

export const localeNames: Record<Locale, string> = {
  de: 'Deutsch',
  ar: 'العربية',
  en: 'English'
}

export const localeFlags: Record<Locale, string> = {
  de: '🇩🇪',
  ar: '🇸🇦',
  en: '🇬🇧'
}

// RTL languages
export const rtlLocales: Locale[] = ['ar']

export function isRTL(locale: Locale): boolean {
  return rtlLocales.includes(locale)
}

// Get locale direction
export function getDirection(locale: Locale): 'ltr' | 'rtl' {
  return isRTL(locale) ? 'rtl' : 'ltr'
}
